import { ISnotrRoute } from '..';

export default [
  {
    path: '/municipalities',
    name: 'Municipalities',
    meta: {
      title: 'TabTitle.municipalities',
      applicationMode: 'PaycheckMode',
    },
    component: () => import('@/pages/municipalities.vue'),
  },
] as ISnotrRoute[];
